import { useState, useEffect } from 'react';
import throttle from 'raf-throttle';
import { isSSR } from './ssr';
export function useViewport(breakpoints) {
    if (breakpoints === void 0) { breakpoints = [768]; }
    var mobile = breakpoints[0], desktop = breakpoints[1];
    var _a = useState(isSSR ? 0 : window.innerWidth), width = _a[0], setWidth = _a[1];
    useEffect(function () {
        var updateWidth = throttle(function () {
            setWidth(window.innerWidth);
        });
        window.addEventListener('resize', updateWidth);
        return function () {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);
    if (typeof desktop === 'number') {
        return {
            width: width,
            isMobile: width < mobile,
            isTablet: width >= mobile && width < desktop,
            isDesktop: width >= desktop
        };
    }
    return {
        width: width,
        isMobile: width < mobile,
        isDesktop: width >= mobile
    };
}
